import React, { useCallback, useContext, useRef } from 'react'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from 'LuxKit/Button/TextButton'
import useToggle from 'hooks/useToggle'
import BodyText from 'LuxKit/Typography/BodyText'
import NavigationHeaderContactDropdown from 'components/App/Header/HeaderMain/NavigationHeader/NavigationHeaderContactDropdown'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import GeoContext from 'contexts/geoContext'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import ContactContext from 'contexts/contactContext'
import { connect } from 'react-redux'
import { getUpcomingOrders } from 'selectors/orderSelectors'
import { NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'

function ContactOptions() {
  const { value: isDropdownOpen, toggle: toggleDropdown, off: closeDropdown } = useToggle(false)
  const triggerRef = useRef<HTMLButtonElement | null>(null)
  const { currentRegionCode } = useContext(GeoContext)
  const currentContact = useContext(ContactContext)

  const defaultContact = currentContact.defaultContact

  const toggleOpen = useCallback(() => {
    toggleDropdown()
  }, [toggleDropdown])

  const contactTagLine = NO_24_7_SUPPORT_REGIONS.includes(currentRegionCode) ? 'Call us 7 days' : 'Call us 24 hours, 7 days'

  return <Group direction="horizontal" verticalAlign="center" gap={4}>
    <BodyText variant="small" wrap="no-wrap">{contactTagLine}</BodyText>
    <TextButton
      ref={triggerRef}
      kind="tertiary"
      onClick={toggleOpen}
      aria-expanded={isDropdownOpen}
      aria-label={contactTagLine + 'contact us'}
      size="small"
      startIcon={<LinePhoneIcon />}
      endIcon={<DropdownChevron open={isDropdownOpen} />}
    >
      {defaultContact.humanReadable}
    </TextButton>
    <CSSBreakpoint min="tablet">
      <NavigationHeaderContactDropdown
        anchorRef={triggerRef}
        open={isDropdownOpen}
        onClose={closeDropdown}
        onItemClick={toggleOpen}
      />
    </CSSBreakpoint>
  </Group>
}

export default connect((state: App.State) => ({
  hasUpcomingOrder: !!getUpcomingOrders(state).length,
  path: state.router.location.pathname,
}))(ContactOptions)
